import { render, staticRenderFns } from "./SortButton.vue?vue&type=template&id=545f2c07"
import script from "./SortButton.vue?vue&type=script&lang=js"
export * from "./SortButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports